import React, { Fragment, useContext } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import Traductor from '../components/Traductor';
import ScrollToTop from '../components/ScrollToTop';
import ListUiItem from './../components/bronson/ListUiItem';
import Button from './../components/bronson/Button';
import MediaTeaser from './../components/bronson/MediaTeaser';
import '../css/pages/contactpage.css';
import Globals from '../Globals';
import { UserContext } from '../contexts/UserContext';

import usePermissions from 'hooks/usePermissions';

const ContactPage = ({ history }) => {
    const t = new Traductor();
    const { checkPermission } = usePermissions();
    const { user } = useContext(UserContext);

    const listContacts = [
        {
            group: 'Dirección',
            ListEmpleados: [
                {
                    name: 'Juan Luis Garcia de Lomas del Valle',
                    phone_1: '+34 629 02 38 33',
                    phone_2: '',
                    email: 'jl.garciadelomas@vwfs.com',
                    position: 'Director',
                    dpto: 'Remarketing',
                    group: 'Gerencia',
                },
            ],
        },
        {
            group: 'Equipo Comercial B2B',
            ListEmpleados: [
                {
                    name: 'Carmen Medina',
                    phone_1: '608 488 692 – ext. 65483',
                    phone_2: '',
                    email: 'carmen.medina@vwfs.com',
                    position: 'Jefa equipo comercial B2B',
                    dpto: 'Remarketing',
                    group: 'Equipo Comercial B2B',
                },
                {
                    name: 'Javier Tamayo',
                    phone_1: '690 031 112 – ext. 65126',
                    phone_2: '',
                    email: 'javier.tamayo@vwfs.com',
                    position: 'Comercial B2B',
                    dpto: 'Remarketing',
                    group: 'Equipo Comercial B2B',
                },
                {
                    name: 'Marta Martínez',
                    phone_1: '669 196 374 – ext. 65124',
                    phone_2: '',
                    email: 'marta.martinez@vwfs.com',
                    position: 'Comercial B2B',
                    dpto: 'Remarketing',
                    group: 'Equipo Comercial B2B',
                },
                {
                    name: 'Raquel Nieves',
                    phone_1: '618 686 290 – ext. 65935',
                    phone_2: '',
                    email: 'raquel.nieves@vwfs.com',
                    position: 'Comercial B2B',
                    dpto: 'Remarketing',
                    group: 'Equipo Comercial B2B',
                },
                {
                    name: 'Teresa Del Monte Martin',
                    phone_1: '606 862 180 – ext. 65045',
                    phone_2: '',
                    email: 'teresa.del.monte.martin@vwfs.com',
                    position: 'Comercial B2B',
                    dpto: 'Remarketing',
                    group: 'Equipo Comercial B2B',
                },
            ],
        },
        {
            group: 'Pagos y logística',
            ListEmpleados: [
                {
                    name: 'Luisa Juanes Delgado',
                    phone_1: '676 991 163 - ext. 65916',
                    phone_2: '',
                    email: 'luisa.juanes@vwfs.com',
                    position: 'Ventas – BackOffice',
                    dpto: 'Remarketing',
                    group: 'Pagos y logística',
                },
                {
                    name: 'Profit Center',
                    phone_1: '669 360 428',
                    phone_2: '',
                    email: 'profit.center@vwfs.com',
                    position: '',
                    dpto: '',
                    group: 'Pagos y logística',
                },
            ],
        },
        {
            group: 'Gestoría y Facturas',
            ListEmpleados: [
                {
                    name: 'Magdalena Sánchez',
                    phone_1: '',
                    phone_2: '',
                    email: 'gestoria.remarketing@vwfs.com',
                    position: 'Gestoría Pradilla',
                    dpto: 'Remarketing - Outsourced',
                    group: 'Gestoría y Facturas',
                },
            ],
        },
        {
            group: 'Transporte',
            ListEmpleados: [
                {
                    name: 'Pilar Díaz',
                    phone_1: '6282 94 058',
                    phone_2: '',
                    email: 'transporte.remarketing@groupecat.com',
                    position: 'Transporte CAT',
                    dpto: 'Remarketing - Outsourced',
                    group: 'Transporte',
                },
            ],
        },
    ];

    const optionsMediaTeaser = [
        {
            textAlt: 'Madrid',
            routeImage: '/Bronson/img/imgOficinas/vwfsMadrid.jpg',
            title: 'Madrid',
            pretitle_1: 'Avenida de Bruselas 34',
            pretitle_2: '',
            body: '20108 Alcobendas (Madrid)',
        },
        {
            textAlt: 'Barcelona',
            routeImage: '/Bronson/img/imgOficinas/vwfsBarcelona.jpg',
            title: 'Barcelona',
            pretitle_1: 'Avda. Baix Llobregat 8',
            pretitle_2: 'Parque de Negocios Mas Blau II',
            body: '08820 El Prat de Llobregat (Barcelona)',
        },
    ];

    const buttonOptions = {
        text: t.getTraduction('Faqs'),
        className: 'u-mt-mini',
        loading: false,
        disabled: false,
    };

    const printMediaTeaser = () => {
        let list = [];
        optionsMediaTeaser.map((mediateaser, index) =>
            list.push(
                <MediaTeaser
                    option={mediateaser}
                    key={'list_media_teaser_' + index}
                />
            )
        );
        return list;
    };

    const printUItemList = () => {
        let listUItem = [];
        listContacts.map(({ group, ListEmpleados }) =>
            listUItem.push(
                <Fragment>
                    <div className="o-component-wrapper">
                        <header className="u-text-left">
                            <p className="u-mb-xsmall u-h2">{group}</p>
                        </header>
                    </div>
                    <ul className="c-list-ui u-mb-xlarge">
                        {ListEmpleados.map((empleado, index) => (
                            <ListUiItem
                                item={empleado}
                                indice={index}
                                key={'list_empleados_' + index}
                            />
                        ))}
                    </ul>
                </Fragment>
            )
        );
        return listUItem;
    };

    const goTo = idDelElemento => {
        let idelement = document.getElementById(idDelElemento);
        let hasta = idelement.offsetTop;
        window.scrollTo(0, hasta);
    };

    const printJumpNavContent = () => {
        if (user.data.Permissions)
            return (
                <ul className="c-jump-nav  js-jump-nav">
                    {checkPermission('CNST_GESTION_COMERCIAL_CONCESIONARIO') ? (
                        <li className="js-jump-nav__item">
                            <a
                                href="#"
                                className=" js-jump-nav__link"
                                onClick={e => {
                                    e.preventDefault();
                                    goTo('contacts-subastas');
                                }}
                                data-scroll-section
                            >
                                <h3>Contacto de Subastas</h3>
                            </a>
                        </li>
                    ) : null}
                    <li className="js-jump-nav__item">
                        <a
                            href="#"
                            className=" js-jump-nav__link"
                            onClick={e => {
                                e.preventDefault();
                                goTo('oficinas');
                            }}
                            data-scroll-section
                        >
                            <h3>Nuestras oficinas</h3>
                        </a>
                    </li>
                </ul>
            );
    };

    return (
        <Fragment>
            <ScrollToTop></ScrollToTop>
            <div
                className="c-hero-teaser c-hero-teaser--shallow "
                data-testid="contactPageTestId"
            >
                <img
                    id="imagen_contactpage"
                    className="landing-image-div c-hero-teaser__image "
                    src={
                        process.env.PUBLIC_URL +
                        '/Bronson/img/imgHeaders/2017_11_11_VWFS_DB_S9_539-1_RZic.jpg'
                    }
                    sizes="100vw"
                    alt="img header"
                ></img>
                <div
                    id="js-hero-teaser-content"
                    className="c-hero-teaser__content "
                >
                    <div className="c-hero-teaser__content-inner">
                        <header className="c-hero-teaser__heading">
                            <div className="c-hero-teaser__title">
                                <h1>
                                    <span className="c-hero-teaser__title-row">
                                        {t.getTraduction('Contact')}
                                    </span>
                                    <br />
                                </h1>
                            </div>
                        </header>
                    </div>
                </div>
            </div>
            <main className="o-main">
                <div className="c-jump-nav-bar  c-horizontal-slider  js-jump-container">
                    <div className="o-page-wrap o-page-wrap--xxsmall">
                        <nav className="c-jump-nav-container">
                            <div className="c-jump-nav-wrapper">
                                {printJumpNavContent()}
                            </div>
                        </nav>
                    </div>
                </div>
                <section className="o-content-section" id="contacts-subastas">
                    <div className="o-page-wrap  o-page-wrap--xxsmall">
                        {checkPermission(
                            'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                        ) ? (
                            <Fragment>
                                <div className="o-component-wrapper">
                                    <header className="u-text-center">
                                        <h2 className="u-mb-xsmall">
                                            Contactos de Subastas
                                        </h2>
                                        <p className="u-mb-xsmall">
                                            Ventas profesionales | Departamento
                                            Remarketing VWFS
                                        </p>
                                        <p className="u-mb-xsmall">
                                            Profit.center@vwfs.com
                                        </p>
                                    </header>
                                </div>
                                <div className="o-component-wrapper">
                                    {printUItemList()}
                                </div>
                            </Fragment>
                        ) : null}
                        <div className="o-component-wrapper" id="oficinas">
                            <header className="u-text-center">
                                <h2 className="u-mb-xsmall">Oficinas</h2>
                                <p className="u-mb-xsmall">
                                    Horario de atención
                                </p>
                                <p className="u-mb-xsmall">
                                    de Lunes a Jueves: 08:00h- 17:30h | Viernes
                                    de 8:00h a 13:45h
                                </p>
                            </header>
                        </div>
                        <div className="o-component-wrapper">
                            <section
                                id="vorteile1"
                                className="o-content-section"
                            >
                                <div className="o-layout">
                                    {printMediaTeaser()}
                                </div>
                            </section>
                        </div>
                        <div className="o-component-wrapper">
                            <header className="u-text-center">
                                <h2 className="u-mb-xsmall">
                                    ¿Tienes más dudas?
                                </h2>
                                <p className="u-mb-xsmall">
                                    Nuestro servicio de Atención al cliente
                                    solucionará cualquier incidencia o duda que
                                    surja. Sin embargo,
                                </p>
                                <p className="u-mb-xsmall">
                                    te adelantamos a continuación la respuesta a
                                    algunas de las preguntas más frecuentes.
                                </p>
                            </header>
                        </div>
                        <div className="o-component-wrapper">
                            <header className="u-text-center">
                                <div className="u-text-center">
                                    <Button
                                        onClick={() =>
                                            history.push(
                                                Globals.APPLICATION_PATH.FAQS
                                            )
                                        }
                                        options={buttonOptions}
                                    ></Button>
                                </div>
                            </header>
                        </div>
                    </div>
                </section>
            </main>
        </Fragment>
    );
};
export default withCookies(withRouter(ContactPage));
